<script setup lang="ts">
    const props = defineProps<{
        blok: AccordeonElementStoryblok;
    }>();
</script>

<template>
    <div class="text">
        <RichText :doc="props.blok.text" />
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/text/text.scss';
</style>
